import { render, staticRenderFns } from "./invoices_details.vue?vue&type=template&id=38e80a78&"
import script from "./invoices_details.vue?vue&type=script&lang=js&"
export * from "./invoices_details.vue?vue&type=script&lang=js&"
import style0 from "./invoices_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports